import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/file-powerpoint': {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M369.9 97.9c9 9 14.1 21.3 14.1 34v332.1c0 26.5-21.5 48-48 48h-288c-26.5 0-48-21.5-48-48v-416c0-26.5 21.5-48 48-48.1h204.1c12.7 0 24.9 5.1 33.9 14.1zM332.1 128l-76.1-76.1v76.1h76.1zM48 464h288v-288h-104c-13.3 0-24-10.7-24-24v-104h-160v416zM120 404v-168c0-6.6 5.4-12 12-12h69.2c36.7 0 62.8 27 62.8 66.3 0 74.3-68.7 66.5-95.5 66.5v47.2c0 6.6-5.4 12-12 12h-24.5c-6.6 0-12-5.4-12-12zM168.5 316.6h23c7.9 0 13.9-2.4 18.1-7.2 8.5-9.8 8.4-28.5 0.1-37.8-4.1-4.6-9.9-7-17.4-7h-23.9v52h0.1z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/file-powerpoint.js
// module id = 1737
// module chunks = 0